import { getMessages } from '../../../../../../store/constants';

export const BACK_TEXT = getMessages().getText('common.back');
